import { render, staticRenderFns } from "./PartnerWithdrawalList.vue?vue&type=template&id=5f1c409a&scoped=true&"
import script from "./PartnerWithdrawalList.vue?vue&type=script&lang=js&"
export * from "./PartnerWithdrawalList.vue?vue&type=script&lang=js&"
import style0 from "./PartnerWithdrawalList.vue?vue&type=style&index=0&id=5f1c409a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c409a",
  null
  
)

export default component.exports